export type RoleNameKey =
	| "platform.roles.sender"
	| "platform.roles.carrier"
	| "platform.roles.asLogisticsCompany"
	| "platform.roles.logisticsCompany"
	| "platform.roles.admin"
	| "";

export const getRoleNameKey = (roleId?: number): RoleNameKey => {
	switch (roleId) {
		case 3:
			return "platform.roles.sender";
		case 4:
			return "platform.roles.carrier";
		case 5:
			return "platform.roles.asLogisticsCompany";
		case 6:
			return "platform.roles.logisticsCompany";
		default:
			return "";
	}
};
